module.exports = __webpack_public_path__ + "img/banner_incorrect_text.0b0f9b4a.svg";